import { DataKeys } from "../../types";
import { HealthLang } from "./healthTypes";
import { HealthLifecycleStageSelector } from "./HealthLifecycleStageSelector";
import {
    healthLifecycleTimelineLine,
    healthLifecycleTimelineList,
    healthLifecycleTimelineRail,
} from "./healthVisualStyles";

interface HealthLifecycleTimelineProps {
    stages: DataKeys[];
    activeIndex: number;
    onSelect: (index: number) => void;
    lang: HealthLang;
}

/** Desktop vertical timeline — thin line, dots, number + title */
export function HealthLifecycleTimeline({
    stages,
    activeIndex,
    onSelect,
    lang,
}: HealthLifecycleTimelineProps) {
    return (
        <nav
            className={`${healthLifecycleTimelineRail} hidden lg:block`}
            role="tablist"
            aria-label="Care lifecycle stages"
        >
            <div className={healthLifecycleTimelineLine} aria-hidden="true" />
            <div className={healthLifecycleTimelineList}>
                {stages.map((stage, index) => (
                    <HealthLifecycleStageSelector
                        key={stage.id ?? index}
                        stage={stage}
                        isActive={index === activeIndex}
                        onSelect={() => onSelect(index)}
                        lang={lang}
                    />
                ))}
            </div>
        </nav>
    );
}
